<template>
  <div class="flex flex-row">
    <div class="  border-gray-200 bg-white">
      <!-- <img src="./assets/navplaceholder.png" class="h-screen" > -->
      <UnifiedNav />
      
    </div>

    <div class="w-full h-screen overflow-y-scroll">
      <NavBar />

      <div class="max-w-[1340px] p-8 flex flex-col justify-start">
        <BannerStepper />
        <!-- <Banner /> -->
        <Dashboard />
        <Insights />

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import "./assets/tailwind.css";
import NavBar from "./components/NavBar";
import Banner from './components/Banner'
import Dashboard from "./components/Dashboard.vue";
import Insights from "./components/Insights.vue";
import BannerStepper from './components/BannerStepper.vue'
import Footer from "./components/Footer.vue";
import ProdcutSwitcher from "./components/navigation/ProdcutSwitcher.vue";
import CbMenu from "./components/CbMenu.vue";
import UnifiedNav from "./components/navigation/UnifiedNav.vue";

export default {
  name: "App",
  components: {
    NavBar,
    Banner,
    Dashboard,
    Insights,
    BannerStepper,
    Footer,
    ProdcutSwitcher,
    CbMenu,
    UnifiedNav
},
};
</script>



<style>
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-leave-to{
    transition: none;
  }
  
  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
  </style>